
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5648897c&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AlertSettings.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AlertSettings.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5648897c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AlertSettings.vue"),
  /* scopeId */
  "data-v-5648897c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/settings/AlertSettings.vue
// module id = 304
// module chunks = 2